<template>
  <div class="tonos-toast-container">
    <img
      class="icon-container"
      width="18"
      height="18"
      v-on:click="closeResponse()"
      :src="
        type === 'success'
          ? require('@/assets/icons/toastsuccessicon.svg')
          : type === 'error'
          ? require('@/assets/icons/toasterroricon.svg')
          : type === 'info'
          ? require('@/assets/icons/toastinfoicon.svg')
          : ''
      "
    />
    <div class="info-container">
      <div class="title-container">{{ title }}</div>
      <div v-if="false" class="date-container">
        Date: {{ date.getDate() }}
        {{ date.toLocaleString("default", { month: "short" }) }},
        {{
          date.toLocaleString("default", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
          })
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: () => 'Hello World',
    },
    date: {
      type: Date,
      required: false,
      default: () => new Date(),
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.Vue-Toastification__toast-component-body {
  display: flex;
  align-items: center;
}
.Vue-Toastification__toast {
  background-color: #fbfcfc;
  color: black;
  padding: 12px 20px 12px 12px;
}

.Vue-Toastification__toast--error {
  background-color: #fffbf2 !important;
  color: #fff;
}
.Vue-Toastification__toast--success {
  background-color: #f2fff5 !important;
  color: #fff;
}
.Vue-Toastification__toast--info {
  background-color: #f2f8ff !important;
  color: #fff;
}
.Vue-Toastification__close-button {
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  padding-left: 20px;
  cursor: pointer;
  transition: 0.3s ease;
  align-items: center;
  color: #052d61;
  opacity: 0.6;
  transition: visibility 0s, opacity 0.2s linear;
}

.tonos-toast-container {
  display: flex;
  flex-direction: row;

  .icon-container {
    margin-right: 13px;
    margin-top: 1px;
  }
  .info-container {
    display: flex;
    flex-direction: column;

    .title-container {
      font-size: 13px;
      font-weight: 500;
      color: #052d61;
    }
    .date-container {
      font-size: 13px;
      font-weight: 500;
      color: #667c99;
    }
  }
}
</style>
